import { Tags } from "@risalabs_frontend_org/oasis-ui-kit";
import { AuthorizationHeaderProps } from "../../../../data-model/authLetterSuccessModel";

/**
 * Header for an authorization card displaying its title, status tag,
 * and date.
 *
 * @param props.title - Title text for the authorization.
 * @param props.status - Status label shown inside the tag.
 * @param props.date - Formatted authorization date/time.
 * @param props.textColor - Tag text color.
 * @param props.bgColor - Tag background color.
 */
const AuthorizationHeader = ({
  title,
  status,
  date,
  textColor,
  bgColor,
}: AuthorizationHeaderProps) => {
  const BASE_CLASS_NAME = "authorization-header-container";
  return (
    <div className={`${BASE_CLASS_NAME} flex flex-col gap-1`}>
      <div
        className={`${BASE_CLASS_NAME}__title text-sm font-bold text-primaryGray-1`}
      >
        {title}
      </div>
      <div
        className={`${BASE_CLASS_NAME}__meta flex items-center gap-2 text-x-tiny text-primaryGray-8`}
      >
        <div className={`${BASE_CLASS_NAME}__status`}>
          <Tags
            label={status}
            textColor={textColor}
            backgroundColor={bgColor}
          />
        </div>
        <div className={`${BASE_CLASS_NAME}__date`}>{date}</div>
      </div>
    </div>
  );
};

export default AuthorizationHeader;
